export const mobileWidth = 561
